import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: { name: 'calculator' },
  },
  {
    name: 'calculator',
    path: '/calculator',
    component: () => import('@/views/calculator/Calculator.vue'),
    meta: {
      title: 'Calculator',
      localeKey: 'calculator.appName',
    },
  },
  {
    name: 'calculator-signup',
    path: '/calculator/signup',
    component: () => import('@/views/calculator-auth/Signup.vue'),
    meta: {
      title: 'Signup',
      localeKey: 'auth.signup',
    },
  },
  {
    name: 'calculator-login',
    path: '/calculator/login',
    component: () => import('@/views/calculator-auth/Login.vue'),
    meta: {
      title: 'Login',
      localeKey: 'auth.login',
    },
  },
  {
    name: 'calculator-activate',
    path: '/calculator/activate',
    component: () => import('@/views/calculator-auth/Activate.vue'),
    meta: {
      title: 'Activate',
      localeKey: 'auth.activate',
    },
  },
  {
    name: 'calculator-reset-password',
    path: '/calculator/reset',
    component: () => import('@/views/calculator-auth/ResetPassword.vue'),
    meta: {
      title: 'Reset Password',
      localeKey: 'auth.resetPassword',
    },
  },
]

export default routes
